module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACABAMAAAAboI1XAAAAHlBMVEWqqqrb29vg4ODc3Nzg4ODe3t7Nzc3g4ODS0tLg4OA+BBIxAAAACXRSTlMajfuR8rU99FAdp9abAAAA60lEQVRo3u2YOw7CMBAFwycR6Wg5Ah3XSEdFTUOfI3CEgGj2tigIaYxLvwIretNtMxpZdmK5McYYY4wxdXAb4od9uarLVPEod7UBatg27unYK2F9ZOOBMNm1Ikx2NYTpLsJ0F2G6izDdRZjuIkx3Eaa7CNNdhJW4Nsf48DzNI2ElrnV8GeeRML2LMH29CNNdhOkuwnQXYYKLTzZhiquNgElzdYPmyn+9uLS9mhKTdoZS/t4FdtmFC+S9Cmxb7QwFjBV01br2di3D5TNkl111uLg45+xilN9g4Ky+DcHrqr5Zobo0xhhjjDGmCt6oiTK6BSSx9QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_docunment.png
// module id = LYZZ
// module chunks = 2